// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-header,.mobile-header .v-toolbar__content{height:50px!important}.mobile-header .hide-filter-button{visibility:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
